<rl-form-table-row>
	<ng-template rlFormTableLabel>Party Group</ng-template>
	<ng-template rlFormTableControl>
		<rl-dropdown-single [(ngModel)]="selectedPartyGroup" (ngModelChange)="updateParams()" [options]="partyGroups"
			[showEmptyOption]="true" [dataLabel]="'partyGroupSelect'">
		</rl-dropdown-single>
	</ng-template>
</rl-form-table-row>